import React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
import { Cancel as CancelIcon, Error as ErrorIcon, Delete as TrashIcon } from '@mui/icons-material';
import colors from '../theme/colors.js';
import Text from './Text.js';
import * as dates from '../services/dates.js';

/**
 * @param notification
 * @param onClick
 * @param classes
 * @param id
 * @param testId
 * @returns {*}
 * @constructor
 */
const Notification = ({
  notification,
  onClick,
  classes,
  id,
  testId,
  customDeleteIcon
}) => {
  const timestamp = dates.formatDateForDisplay(notification.timestamp, 'lll');
  const styles = {
    listItemIcon: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: 35
    },
    listItem: {
      maxWidth: 800,
      borderRadius: 2,
      boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginBottom: 5,
      minWidth: 500
    },
    listItemError: {
      paddingTop: 15,
      paddingBottom: 15
    },
    blue: {
      backgroundColor: '#E0F5F7'
    },
    yellow: {
      backgroundColor: '#F7F2C2'
    },
    inline: {
      display: 'inline'
    }
  };
  if (typeof notification.data.errorTrace === 'object') {
    notification.data.errorTrace = JSON.stringify(notification.data.errorTrace);
  }
  if (notification.metaID.toUpperCase().includes('ERR')) {
    return /*#__PURE__*/React.createElement(ListItem, {
      style: {
        ...styles.listItem,
        ...styles.yellow,
        ...styles.listItemError
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, {
      styles: styles.listItemIcon
    }, /*#__PURE__*/React.createElement(CancelIcon, {
      style: {
        color: '#414042'
      }
    })), /*#__PURE__*/React.createElement(ListItemText, {
      disableTypography: true,
      primary: /*#__PURE__*/React.createElement(Text, {
        id: id || testId,
        medium: true,
        customStyle: {
          fontWeight: 600
        }
      }, notification.data.message),
      secondary: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("pre", {
        style: {
          fontFamily: '"AvenirLTPro-Light", sans-serif',
          margin: "5px 0 0 0",
          fontSize: '14px',
          overflowX: 'auto',
          whiteSpace: 'pre-wrap',
          wordWrap: 'break-word',
          overflowWrap: 'anywhere'
        }
      }, notification.data.errorTrace), /*#__PURE__*/React.createElement(Text, {
        tiny: true,
        margin: "5px 0 0 0"
      }, `${notification.type} | ${timestamp}`))
    }), /*#__PURE__*/React.createElement(IconButton, {
      "aria-label": "delete",
      onClick: () => onClick(notification),
      sx: {
        padding: "12px",
        '&.MuiButtonBase-root:hover': {
          backgroundColor: colors.hoverGrey
        },
        '&.MuiButtonBase-root': {
          ...customDeleteIcon
        }
      }
    }, /*#__PURE__*/React.createElement(TrashIcon, {
      style: {
        color: '#414042'
      }
    })));
  }
  return /*#__PURE__*/React.createElement(ListItem, {
    style: {
      ...styles.listItem,
      ...styles.blue
    }
  }, /*#__PURE__*/React.createElement(ListItemIcon, {
    style: styles.listItemIcon
  }, /*#__PURE__*/React.createElement(ErrorIcon, {
    sx: {
      color: '#414042',
      '&.MuiButtonBase-root:hover': {
        backgroundColor: colors.hoverGrey
      }
    }
  })), /*#__PURE__*/React.createElement(ListItemText, {
    disableTypography: true,
    primary: /*#__PURE__*/React.createElement(Text, {
      id: id || testId,
      medium: true,
      customStyle: {
        fontWeight: 600
      }
    }, notification.data),
    secondary: /*#__PURE__*/React.createElement(Text, {
      tiny: true
    }, `${notification.type} | ${timestamp}`)
  }), /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "delete",
    onClick: () => onClick(notification),
    sx: {
      padding: "12px",
      '&.MuiButtonBase-root:hover': {
        backgroundColor: colors.hoverGrey
      },
      '&.MuiButtonBase-root': {
        ...customDeleteIcon
      }
    }
  }, /*#__PURE__*/React.createElement(TrashIcon, {
    sx: {
      color: '#414042'
    }
  })));
};

/**
 *
 * @param {*} theme
 */

export default Notification;